'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var RIGHT_ALIGNED = exports.RIGHT_ALIGNED = 'RIGHT_ALIGNED';
var LEFT_ALIGNED = exports.LEFT_ALIGNED = 'LEFT_ALIGNED';